import { CreateClientInformationRecordRequestDto } from './create-client-information-record.request.dto';
import { ConditionalPartial } from '../../../utils';

/**
 * DTO for updating client information record fields
 * All fields are optional for partial updates
 * Uses PartialType on backend, class-as-is on frontend
 */
export class UpdateClientInformationRecordRequestDto extends ConditionalPartial(
    CreateClientInformationRecordRequestDto,
) {}
